module.exports = __webpack_public_path__ + "static/media/06.c0f79b41.svg";